import { apiFetch } from "./apiClient";

export async function sendNotification(notificationData) {
  const res = await apiFetch("/api/services/notifications", {
    method: "POST",
    body: JSON.stringify(notificationData),
  });
  if (!res.ok) {
    throw new Error("Failed to send notification");
  }
  return res.json();
}
